export const socialSharingModalId = 'social-sharing-modal-id';
